import React from 'react';
interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}
export const ToggleSwitch = ({
  checked,
  onChange
}: ToggleSwitchProps) => {
  return <div className="flex items-center" data-id="element-429">
      <button type="button" role="switch" aria-checked={checked} onClick={() => onChange(!checked)} className={`relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${checked ? 'bg-green-500' : 'bg-gray-200'}`} data-id="element-430">
        <span className={`pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200 ${checked ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-431" />
      </button>
      <span className="ml-2 text-sm text-gray-500" data-id="element-432">
        {checked ? 'Yes' : 'No'}
      </span>
    </div>;
};